import { useRouter } from 'next/router';
import { useMutation } from '@apollo/client';
import { deleteCompanyQuery } from '../queries';

export const useProfileLogout = () => {
  const router = useRouter();
  const [logout, { loading: mutationLoading }] =
    useMutation(deleteCompanyQuery);

  const handleLogout = () => {
    logout().then(data => {
      if (data?.data?.signOut?.profile?.id) {
        router.push('/');
      }
    });
  };

  return {
    mutationLoading,
    handleLogout
  };
};
